const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightarc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480.829,
    height: 889.547,
    viewBox: "0 0 480.829 889.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3048",
    d: "m1636.393 1229.219-299.823-.01q-.034 24.473 1.752 48.726a654.132 654.132 0 0 0 190.434 415.235l212.144-212.149a355.6 355.6 0 0 1-104.507-251.802z",
    style: {
      fill: "#83c522"
    },
    transform: "translate(-1336.569 -972.101)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3054",
    d: "M1817.4 1539.315a355.485 355.485 0 0 1-76.493-58.293l-212.15 212.148a653.9 653.9 0 0 0 288.643 168.478z",
    style: {
      fill: "#45a82c"
    },
    transform: "translate(-1336.569 -972.101)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3055",
    d: "M1388.9 972.1a412.854 412.854 0 0 0-2.274 5.353c-.885 2.13-1.721 4.281-2.585 6.421-1.074 2.663-2.165 5.323-3.2 8-.9 2.328-1.76 4.672-2.633 7.01-.944 2.514-1.9 5.023-2.809 7.55-.866 2.422-1.7 4.854-2.547 7.287-.859 2.467-1.725 4.935-2.555 7.413s-1.624 4.984-2.42 7.48c-.781 2.436-1.569 4.871-2.321 7.316-.785 2.556-1.537 5.118-2.3 7.681-.707 2.4-1.415 4.808-2.1 7.228q-1.1 3.929-2.155 7.873c-.635 2.367-1.27 4.74-1.876 7.117q-1.035 4.033-2.015 8.083-.845 3.493-1.661 6.987-.957 4.141-1.863 8.3-.742 3.419-1.452 6.85-.883 4.254-1.706 8.525c-.427 2.211-.833 4.428-1.241 6.644q-.8 4.416-1.553 8.839-.537 3.176-1.025 6.359a702.267 702.267 0 0 0-1.4 9.184c-.284 1.989-.544 3.982-.812 5.976-.43 3.217-.853 6.433-1.235 9.655-.211 1.794-.4 3.588-.6 5.384-.379 3.44-.754 6.883-1.074 10.328-.14 1.468-.252 2.938-.38 4.405-.329 3.786-.655 7.569-.918 11.369-.065.892-.105 1.79-.166 2.686q-1.431 21.807-1.427 43.8l299.794.006a355.479 355.479 0 0 1 86.568-233.554 27.555 27.555 0 0 0 6.153-23.56z",
    style: {
      fill: "#bde131"
    },
    transform: "translate(-1336.569 -972.101)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarc);
export default __webpack_public_path__ + "static/media/rightarc.6ffd1ca3c3b5c380106aaa0e22ef9f4d.svg";
export { ForwardRef as ReactComponent };